import * as React from 'react';
import { liveAnnounce, Level } from 'uitk-react-utils';
import { useLocalization } from '@shared-ui/localization-context';
import { getAriaLiveDate } from './calendar-utils/intl.esm.js';

var translationKeyMap = {
    SelectionStartHasChanged: 'calendar.checkinSelected.a11yLabel',
    SelectionEndHasChanged: 'calendar.checkoutSelected.a11yLabel',
    StartDateCleared: 'calendar.checkinCleared.a11yLabel',
    EndDateCleared: 'calendar.checkoutCleared.a11yLabel',
    BothDatesAreCleared: 'calendar.datesCleared.a11yLabel',
    NoChange: ''
};
var AriaLive = function (_a) {
    var selectionStart = _a.selectionStart, selectionEnd = _a.selectionEnd, locale = _a.locale;
    var previousSelectionStartRef = React.useRef(selectionStart);
    var previousSelectionStart = previousSelectionStartRef.current;
    var previousSelectionEndRef = React.useRef(selectionEnd);
    var previousSelectionEnd = previousSelectionEndRef.current;
    var l10n = useLocalization();
    var ariaLiveScenario = React.useMemo(function () {
        var selectionStartHasChanged = selectionStart && previousSelectionStart !== selectionStart;
        if (selectionStartHasChanged) {
            return {
                state: 'SelectionStartHasChanged',
                updateSelectionStart: true,
                date: selectionStart
            };
        }
        var selectionEndHasChanged = selectionEnd && previousSelectionEnd !== selectionEnd;
        if (selectionEndHasChanged) {
            return {
                state: 'SelectionEndHasChanged',
                updateSelectionEnd: true,
                date: selectionEnd
            };
        }
        var areBothSelectionItemsCleared = previousSelectionStart && previousSelectionEnd && !selectionStart && !selectionEnd;
        if (areBothSelectionItemsCleared) {
            return {
                state: 'BothDatesAreCleared',
                updateSelectionStart: true,
                updateSelectionEnd: true,
                date: selectionStart
            };
        }
        var isStartSelectionCleared = previousSelectionStart && !selectionStart;
        if (isStartSelectionCleared) {
            return {
                state: 'StartDateCleared',
                updateSelectionStart: true,
                date: selectionStart
            };
        }
        var isEndSelectionCleared = previousSelectionEnd && !selectionEnd;
        if (isEndSelectionCleared) {
            return {
                state: 'EndDateCleared',
                updateSelectionEnd: true,
                date: selectionEnd
            };
        }
        return {
            state: 'NoChange'
        };
    }, [previousSelectionStart, selectionStart, previousSelectionEnd, selectionEnd]);
    if (ariaLiveScenario.updateSelectionStart) {
        previousSelectionStartRef.current = selectionStart;
    }
    if (ariaLiveScenario.updateSelectionEnd) {
        previousSelectionEndRef.current = selectionEnd;
    }
    var translationKey = translationKeyMap[ariaLiveScenario.state];
    var translationDate = getAriaLiveDate(ariaLiveScenario.date || null, locale);
    var ariaLiveLabel = translationKey ? l10n.formatText(translationKey, translationDate) : '';
    React.useEffect(function () {
        if (ariaLiveLabel) {
            liveAnnounce(ariaLiveLabel, Level.POLITE);
        }
    }, [ariaLiveLabel]);
    return null;
};
var AriaLive$1 = React.memo(AriaLive);

export { AriaLive$1 as default };
